import React, { useEffect } from "react"
import { htmlToReactElementWithInnerHtml } from "./htmlToReactElementWithInnerHtml"
import useComponentResizeFinished from "../../hooks/useComponentResizeFinished"

const Html = props => {
  const htmlCompRef = React.createRef()
  useComponentResizeFinished(htmlCompRef)

  return (
    <React.Fragment>
      {htmlToReactElementWithInnerHtml(props.data.text, htmlCompRef)}
    </React.Fragment>
  )
}

export default Html
